import zod from "zod";
import { uuid } from "./common";
import { contextInstanceVariableSchema } from "./contextInstance";

export const createNextNavigationPropsSchema = zod.object({
    processInstanceId: uuid,
    contextVariablesToUpdate: zod.array(contextInstanceVariableSchema),
    timeSpent: zod.number(),
});

export const createPreviousNavigationPropsSchema = zod.object({
    processInstanceId: uuid,
    timeSpent: zod.number(),
});

export type CreateNextNavigationPropsType = zod.infer<typeof createNextNavigationPropsSchema>;
export type CreatePreviousNavigationPropsType = zod.infer<
    typeof createPreviousNavigationPropsSchema
>;
